import { Analytics }          from '@geenee/analytics';
import { inject, injectable } from "inversify";

@injectable()
export class RootAnalytics extends Analytics {
    constructor(@inject('<AnalyticsProvider>') provider, disabled = process.env.NODE_ENV !== 'production') {
        super(provider, disabled);
    }
}
